import { memo } from 'react';

import Tag from 'shared/Tag';

interface IProps {
  hasOffer: boolean;
}

const OfferTag: React.FC<IProps> = ({ hasOffer }) => {
  if (!hasOffer) {
    return null;
  }

  return <Tag text='Oferta' />;
};

export default memo(OfferTag);
